module.exports = __webpack_public_path__ + "static/img/bglight.c687b990.png";